import { createRoot } from "react-dom/client";

import React from "react";
import { AppContextProvider } from "./contexts/app-context";
import { EnvContextProvider } from "./contexts/env-context";

import { BusyBlocker } from "./components/busy-blocker";
import { UnsuportedBrowserDialog } from "./components/dialogs/unsupported-browser-dialog";
import { ErrorBoundary } from "./components/error-boundary";
import { ErrorContextProvider } from "./components/error-boundary/context";
import { WhyDidYouRerender } from "./components/why-did-you-rerender";
import { BusyBlockerContextProvider } from "./contexts/busy-blocker-context";
import { Router } from "./router";

const container = document.getElementById("mobile-app");

if (container) {
	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<EnvContextProvider>
				<AppContextProvider>
					<WhyDidYouRerender />
					<BusyBlockerContextProvider>
						<ErrorContextProvider>
							<ErrorBoundary>
								<UnsuportedBrowserDialog>
									<Router />
									<BusyBlocker />
								</UnsuportedBrowserDialog>
							</ErrorBoundary>
						</ErrorContextProvider>
					</BusyBlockerContextProvider>
				</AppContextProvider>
			</EnvContextProvider>
		</React.StrictMode>,
	);
}
